// components/Footer.jsx
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-12 md:mt-16 pt-6 md:pt-8 pb-8 md:pb-10 text-center border-t border-gray-200">
      <div className="mb-4">
        <h3 className="text-base md:text-lg font-semibold text-gray-700 mb-2">Contact Us</h3>
        <p className="text-sm md:text-base text-gray-600 px-4">
          For queries: <a href="tel:+919391034913" className="text-blue-600 hover:underline">9391034913</a>, <a href="tel:+919949648214" className="text-blue-600 hover:underline">9949648214</a>
        </p>
    {/* <p className="text-gray-600">Email: aolhyderabad@example.com</p>*/}
      </div>

      <div className="text-xs md:text-sm text-gray-500 px-4">
        &copy; {currentYear} Art of Living, Hyderabad. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;